/*
 * Footer accordion state (sections/custom-footer.liquid).
 *
 * The footer columns are <details> elements. On desktop they must always be
 * open and non-collapsible (the summary is made non-interactive in CSS); on
 * mobile they collapse, starting closed. We force the open state per breakpoint
 * and only re-apply when crossing 750px, so a shopper's manual toggles on mobile
 * are preserved. Server-rendered `open` means a no-JS visitor sees everything.
 */
(function () {
  if (window.__customFooterInit) return;
  window.__customFooterInit = true;

  var mq = window.matchMedia('(min-width: 750px)');

  function apply() {
    var open = mq.matches;
    document.querySelectorAll('[data-footer-accordion]').forEach(function (details) {
      details.open = open;
    });
  }

  apply();

  if (mq.addEventListener) {
    mq.addEventListener('change', apply);
  } else if (mq.addListener) {
    mq.addListener(apply); // Safari < 14
  }

  // Theme editor re-renders the footer section.
  document.addEventListener('shopify:section:load', apply);

  /*
   * Newsletter success is one-time. The customer form redirects back with
   * ?customer_posted=true plus an anchor that scrolls the page to the success
   * message. Once that has rendered (and the browser has scrolled to it), strip
   * the param + hash via replaceState so a reload doesn't re-show the success
   * state or scroll again. Runs only when the success message is present, i.e.
   * right after a submit.
   */
  if (document.querySelector('[data-newsletter-success]')) {
    var cleanNewsletterUrl = function () {
      try {
        var url = new URL(window.location.href);
        var changed = false;
        if (url.searchParams.has('customer_posted')) {
          url.searchParams.delete('customer_posted');
          changed = true;
        }
        if (url.hash) {
          url.hash = '';
          changed = true;
        }
        if (changed) {
          window.history.replaceState(null, document.title, url.pathname + url.search);
        }
      } catch (error) {
        /* replaceState unavailable — leave the URL as-is */
      }
    };

    // Wait for `load` so the browser's anchor scroll has already happened.
    if (document.readyState === 'complete') {
      cleanNewsletterUrl();
    } else {
      window.addEventListener('load', function () {
        requestAnimationFrame(cleanNewsletterUrl);
      });
    }
  }
})();
